export default {
  background: "#02111B",
  btnColor: "#FFC857",
  blackColor: "#07070A",
  dropdownColor: "#16232C",
  greytxtcolor: "#9CA3AF",
  greybordercolor: "#374151",
  primary: "#ffc857", //yellowish
  secondary: "#bb0a21", //redish
  white: "#ffffff",
  drawerBgColor: "#16232c",
  pageBgColor: "#041A29",
  background: "#02111b",
  btnColor: "#FFC857",
  blackColor: "#000",
  greytxtcolor: "#9CA3AF",
  greybordercolor: "#374151",
  redColor: "#ed1c24",
  greenColor: "#00a651",
  halfBlack: "rgba(0,0,0,0.5)",
  transparent: "transparent",
  white: "#ffffff",
  mutedWhite: "#9CA3AF",
  drawerBgColor: "#16232c",
  pageBgColor: "#16232c",
  background: "#02111b",
  btnColor: "#FFC857",
  blackColor: "#000",
  dropdownColor: "#16232C",
  greytxtcolor: "#9CA3AF",
  greybordercolor: "#374151",
  redColor: "#ed1c24",
  greenColor: "#00a651",
  blueColor: "#00a8ff",
  primary: "#ffc857", //yellowish
  secondary: "#bb0a21", //redish
  white: "#ffffff", //white
  drawerBgColor: "#16232c",
  rootBgColor: "#02111b",
  pageBgColor: "#16232c",
};

export const getKOTBgColor = (status) => {
  switch (status) {
    case "pending":
      return "#691726";
    case "cooking":
      return "#FFC857";
    case "completed":
    case "served":
      return "#00A651";
    // #16232c
  }
};

export const getKOTTextColor = (status) => {
  switch (status) {
    case "pending":
      return "#fff";
    case "cooking":
      return "#000";
    case "completed":
    case "served":
      return "#fff";
    // #16232c
  }
};